// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1bae39ba","732":"735500df","977":"0edd3677"}[chunkId] + ".chunk.js";
};